/**
 * Bestemmer gjeldende byggeforskrift (TEK) basert på byggeår eller renoveringsår
 *
 * OPPHAVSRETT OG KILDER:
 * - Byggeforskrifter (TEK): © Kommunal- og distriktsdepartementet
 * - Kilde: Lovdata.no - https://lovdata.no
 * - Tilgjengeliggjort under offentlig lisens
 * - Denne koden tolker og refererer til offentlige forskrifter
 *
 * Viktig prinsipp:
 * - Et bygg/rom/bygningsdel skal vurderes mot forskriften som gjaldt ved oppføring/renovering
 * - Kosmetiske oppdateringer (maling, overflater) utløser IKKE krav om ny forskrift
 * - Større renoveringer (nytt bad, nytt tak, etc.) utløser krav om gjeldende forskrift på det tidspunktet
 */

export const TEK_PERIODER = [
  {
    id: 'tek17',
    navn: 'TEK17',
    fulltnavn: 'Forskrift om tekniske krav til byggverk (TEK17)',
    aar_fra: 2017,
    aar_til: null, // Gjeldende
    beskrivelse: 'Gjeldende fra 1. juli 2017',
    referanse: 'FOR-2017-06-19-840',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/SF/forskrift/2017-06-19-840'
  },
  {
    id: 'tek10',
    navn: 'TEK10',
    fulltnavn: 'Forskrift om tekniske krav til byggverk (TEK10)',
    aar_fra: 2010,
    aar_til: 2016,
    beskrivelse: 'Gjeldende fra 1. juli 2010 til 30. juni 2017',
    referanse: 'FOR-2010-03-26-489',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/SF/forskrift/2010-03-26-489'
  },
  {
    id: 'tek07',
    navn: 'TEK (2007)',
    fulltnavn: 'Tekniske forskrifter til plan- og bygningsloven 2007',
    aar_fra: 2007,
    aar_til: 2009,
    beskrivelse: 'Gjeldende fra 1. februar 2007 til 30. juni 2010',
    referanse: 'FOR-1997-01-22-33 (endret 2007)',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/LTI/forskrift/1997-01-22-33'
  },
  {
    id: 'tek03',
    navn: 'TEK (2003)',
    fulltnavn: 'Tekniske forskrifter til plan- og bygningsloven 2003',
    aar_fra: 2003,
    aar_til: 2006,
    beskrivelse: 'Gjeldende fra 1. januar 2003 til 31. januar 2007',
    referanse: 'FOR-1997-01-22-33 (endret 2003)',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/LTI/forskrift/1997-01-22-33'
  },
  {
    id: 'tek01',
    navn: 'TEK (2001)',
    fulltnavn: 'Tekniske forskrifter til plan- og bygningsloven 2001',
    aar_fra: 2001,
    aar_til: 2002,
    beskrivelse: 'Gjeldende fra 1. januar 2001 til 31. desember 2002',
    referanse: 'FOR-1997-01-22-33 (endret 2001)',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/LTI/forskrift/1997-01-22-33'
  },
  {
    id: 'tek99',
    navn: 'TEK (1999)',
    fulltnavn: 'Tekniske forskrifter til plan- og bygningsloven 1999',
    aar_fra: 1999,
    aar_til: 2000,
    beskrivelse: 'Gjeldende fra 1. januar 1999 til 31. desember 2000',
    referanse: 'FOR-1997-01-22-33 (endret 1999)',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/LTI/forskrift/1997-01-22-33'
  },
  {
    id: 'tek97',
    navn: 'TEK97',
    fulltnavn: 'Forskrift om krav til byggverk og produkter til byggverk (TEK)',
    aar_fra: 1997,
    aar_til: 1998,
    beskrivelse: 'Gjeldende fra 1. januar 1997 til 31. desember 1998',
    referanse: 'FOR-1997-01-22-33',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/LTI/forskrift/1997-01-22-33'
  },
  {
    id: 'bygg87',
    navn: 'Byggeforskrift 1987',
    fulltnavn: 'Byggeforskrift 1987',
    aar_fra: 1987,
    aar_til: 1996,
    beskrivelse: 'Gjeldende fra 1987 til 31. desember 1996',
    referanse: 'FOR-1985-06-14-77 (endret 1987)',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/LTI/forskrift/1985-06-14-77'
  },
  {
    id: 'bygg85',
    navn: 'Byggeforskrift 1985',
    fulltnavn: 'Byggeforskrift 1985',
    aar_fra: 1985,
    aar_til: 1986,
    beskrivelse: 'Gjeldende fra 1985 til 1986',
    referanse: 'FOR-1985-06-14-77',
    kilde: 'Lovdata.no',
    lovdata_url: 'https://lovdata.no/dokument/LTI/forskrift/1985-06-14-77'
  },
  {
    id: 'bygg69',
    navn: 'Byggeforskrift 1969',
    fulltnavn: 'Byggeforskrifter av 1. august 1969',
    aar_fra: 1969,
    aar_til: 1984,
    beskrivelse: 'Gjeldende fra 1. august 1969 til 1984',
    referanse: 'Byggeforskrifter av 1. august 1969',
    kilde: 'Kommunal- og arbeidsdepartementet',
    lovdata_url: null
  },
  {
    id: 'eldre',
    navn: 'Eldre forskrifter',
    fulltnavn: 'Byggeforskrifter før 1969',
    aar_fra: null,
    aar_til: 1968,
    beskrivelse: 'Bygg oppført før 1969',
    referanse: 'Lokale byggeforskrifter',
    kilde: 'Lokale myndigheter',
    lovdata_url: null
  }
];

/**
 * Finn gjeldende TEK-periode basert på år
 * @param {number} aar - Byggeår eller renoveringsår
 * @returns {object} TEK-periode objekt
 */
export function finnGjeldendeTEK(aar) {
  if (!aar) {
    return null;
  }

  for (const periode of TEK_PERIODER) {
    if (periode.aar_til === null && aar >= periode.aar_fra) {
      return periode;
    }

    if (periode.aar_fra === null && aar <= periode.aar_til) {
      return periode;
    }

    if (aar >= periode.aar_fra && aar <= periode.aar_til) {
      return periode;
    }
  }

  return TEK_PERIODER[TEK_PERIODER.length - 1]; // Fallback til "eldre forskrifter"
}

/**
 * Bestem referanseår for et rom eller en bygningsdel
 * @param {number} byggeaar - Bygningens byggeår
 * @param {number} renoveringsaar - Rom/bygningsdel sitt renoveringsår (valgfritt)
 * @returns {object} { aar, tek, erRenovert }
 */
export function bestemReferanseaar(byggeaar, renoveringsaar) {
  const aar = renoveringsaar || byggeaar;
  const tek = finnGjeldendeTEK(aar);

  return {
    aar,
    tek,
    erRenovert: !!renoveringsaar
  };
}

/**
 * Generer forklarende tekst for forskriftsreferanse
 * @param {number} byggeaar
 * @param {number} renoveringsaar
 * @returns {string}
 */
export function forklarReferanse(byggeaar, renoveringsaar) {
  const ref = bestemReferanseaar(byggeaar, renoveringsaar);

  if (ref.erRenovert) {
    return `Renovert ${ref.aar} - vurderes mot ${ref.tek.navn}`;
  }

  return `Oppført ${ref.aar} - vurderes mot ${ref.tek.navn}`;
}
